// Leituras feitas uma vez por sessão (até F5, login novo ou signOut), guardadas só em memória.
// Quem pede a mesma chave enquanto a leitura está em voo recebe a mesma promessa; uma falha não
// fica guardada, então a próxima montagem que precisar tenta de novo (AD-023).

const sessionReads = new Map<string, Promise<unknown>>();

export const SESSION_KEYS = {
  selos: (playerId: string) => `selos:${playerId}`,
  teamsRecognition: (playerId: string) => `teams-recognition:${playerId}`,
  // `GET challenge` do quadrante GT35: igual para todos os players, então a chave não leva id.
  challengeHome: () => 'challenge-home',
  group: (playerId: string, cycleTitle?: string) => `group:${playerId}:${cycleTitle ?? ''}`,
  notifications: (playerId: string) => `notifications:${playerId}`,
  // `find/help` não recebe parâmetro: a mesma lista para todos.
  help: () => 'help',
  userNotifications: (playerId: string) => `user-notifications:${playerId}`,
  news: (playerId: string) => `news:${playerId}`,
  teamsSurvey: (playerId: string) => `teams-survey:${playerId}`,
};

export function readOncePerSession<T>(key: string, fetcher: () => Promise<T>): Promise<T> {
  const existing = sessionReads.get(key);
  if (existing) return existing as Promise<T>;

  // Só a leitura que ainda é dona da chave apaga a entrada: a falha atrasada de antes de uma
  // limpeza ou de um setSessionValue não pode desfazer o que veio depois.
  const ownsKey = () => sessionReads.get(key) === read;

  const read: Promise<T> = fetcher().catch(error => {
    if (ownsKey()) sessionReads.delete(key);
    throw error;
  });

  sessionReads.set(key, read);
  return read;
}

export function setSessionValue<T>(key: string, value: T): void {
  sessionReads.set(key, Promise.resolve(value));
}

export function clearSessionReads(): void {
  sessionReads.clear();
}
